import { FC } from 'react';
import { Circle, SquareProps } from '@chakra-ui/react';

export const Indicator: FC<SquareProps> = (props) => (
  <Circle bgColor="red.-1" marginLeft="space-8" size="6px" {...props} />
);
